/**
 * Copyright (c) 20240701, Mohamed eRrais (merrais / MeR) 
 * from tajwyd.akademy.ma
 * logo.png Compressed from digitalservices.ma
 * from sync.2us.ma 
 */

import {base} from '../app'

export const enConfig = {
    ...base,
    bismi : 'In the name of God, the Most Gracious, the Most Merciful.',
    salaam :'Salaam',

    header:{
        joinus : "Join us",
        signin : "Login",    
        signout: "Exit",
        close: "Close",
        profile: "Profile",
        email: "Email",
        phone: "Phone",
        signup : "Sign Up",
        about : "About",
        article : "Articles",
        contact : "Contact",
        download: "Download",
    },
    
    home:{
        title:base.name, 
        login:'Login',
        connected: 'You must be registered',
        about:'aims to introduce the new generation to the new world of knowledge'

    },

    profile:{
        salaam :'Hi, ',
        setting:'Settings',
        contact:'Contact',
        logout:'Sign Out',
        site:'Site',
        service:'Services',
        article:'Articles',
        profile:'Profile',
        home:'Home',
        contact:'Contact',
        salaat:'Salaat',
        english:'English',
        setting:'Settings',
        invoice:'Invoices',
        login:'Login',
        admin:'Admin',
        roles: [{Id:1, Value:'Student'},{Id:2, Value:'Teacher'},{Id:3, Value:'Manager'},{Id:4, Value:'Admin'}] 
    },

    blog:{
        title :'Most Interesting Articles',
        read:'Read more...'
    },

    contact:{
        title:'Get In Touch',
        message:'Please fill out the form below to send us an email',
        confirm:'Contact Confirming',
        content:'Please fill out the code we sent you by email to confirm it',
        recipient:"Please confirm the recipient's information.",
        feedback : 'We have received your message, we will get back to you as soon as possible',
        warning : "Need to confirm your email before proceeding"
    },


    getApp : {
        name : 'Download ServicesApp',
        info : 'Download Services App'
    },

}
